export default __webpack_public_path__ + "static/media/web3diagram.fad333d5.svg";